export default __webpack_public_path__ + "static/media/libra.f23186b8.png";